import { mapGetters } from 'vuex';
import debounce from '@/helpers/debounce';

import Arrow from '@/assets/listing/arrow_accordion.svg';
import More from '@/assets/listing/more.svg';
import Men from '@/assets/listing/mens.svg';
import ArrowFilter from '@/assets/listing/arrow_classify.svg';

import enums from '@/helpers/enums';

export default {
  name: 'Mixin',
  components: {
    Arrow,
    More,
    Men,
    ArrowFilter,
  },
  props: ['sort', 'search', 'currentPage'],
  data() {
    return {
      openResumesGroup: null,
      editMenu: null,
      isSharedIcon: null,
      fetch: false,
      sharedInformation: { collabos: {} },
      searchDebounce: () => {},
      workspaceTypes: enums.workspaceTypes,
    };
  },
  mounted() {
    this.searchDebounce = debounce(this.launchSearch, 300);
  },
  methods: {
    openEditMenu(id) {
      if (this.editMenu !== id) {
        this.editMenu = id;
      } else {
        this.editMenu = null;
      }
    },
    async openIsShared(id) {
      if (this.isSharedIcon === null && this.fetch === false) {
        this.fetch = true;
        this.isSharedIcon = id;
        const result = await this.$store.dispatch('resumes.share.getById', {
          resumeId: id,
        });
        if (this.isSharedIcon === id) {
          this.sharedInformation = result;
        }
      }
    },
    async sortBy(sort) {
      this.editMenu = null;
      this.$emit('sortBy', sort);
    },
    async remove(resume, resumeGroup) {
      this.editMenu = null;
      try {
        const result = await this.$store.dispatch('setPopup', {
          popupType: 'ConfirmPopup',
          popupData: {
            title: this.$t('popUp.removeResume.title', {
              resume: resume.candidate.firstname,
            }),
            content: this.$t('popUp.removeResume.content'),
            company: false,
            confirm: this.$t('popUp.removeResume.button'),
            delete: true,
          },
        });
        if (result) {
          if (resumeGroup) {
            if (resume.id === resumeGroup.resumes[0].id) this.openResumesGroup = resumeGroup.resumes[1].id;
            if (resumeGroup.resumes.length <= 2) this.openResumesGroup = null;
          }
          await this.$store.dispatch('resumes.delete', resume.id);
          this.$emit('reload');
        }
      } catch (e) {
        console.error(e);
      }
    },
    async moveResumes(resume, resumeGroup) {
      this.editMenu = null;
      try {
        const result = await this.$store.dispatch('setPopup', {
          popupType: 'ConfirmPopup',
          popupData: {
            title: this.$t('popUp.moveResume.title', {
              resume: resume.candidate.firstname,
            }),
            content: this.$t('popUp.moveResume.content', {
              resume: resume.candidate.firstname,
            }),
            company: false,
            confirm: this.$t('popUp.moveResume.button'),
          },
        });
        if (result) {
          if (resumeGroup) {
            if (resume.id === resumeGroup.resumes[0].id) this.openResumesGroup = resumeGroup.resumes[1].id;
            if (resumeGroup.resumes.length <= 2) this.openResumesGroup = null;
          }
          await this.$store.dispatch('resumes.organization.edit', {
            resumeId: resume.id,
            organizationId: this.user.organization.id,
          });
          this.$emit('reload');
        }
      } catch (e) {
        console.error(e);
      }
    },
    async duplicate(resume) {
      this.editMenu = null;
      try {
        const id = (
          await this.$store.dispatch('setPopup', {
            popupType: 'DuplicateResume',
            popupData: resume,
          })
        ).id;
        if (id) {
          await this.$router.push({ name: 'editor', params: { id } });
        }
      } catch (e) {
        console.error(e);
      }
    },
    async updateLabels(resume) {
      this.editMenu = null;

      try {
        await this.$store.dispatch('setPopup', {
          popupType: 'UpdateResumeLabels',
          popupData: resume,
        });

        this.$emit('reload');
      } catch (e) {
        console.error(e);
      }
    },
    async share(resume) {
      this.$emit('share', resume);
    },
    async unshared(resume) {
      this.editMenu = null;
      try {
        const result = await this.$store.dispatch('setPopup', {
          popupType: 'ConfirmPopup',
          popupData: {
            title: this.$t('popUp.unsharedResume.title', {
              resume: resume.candidate.firstname,
            }),
            content: this.$t('popUp.unsharedResume.content', {
              resume: resume.candidate.firstname,
            }),
            company: false,
            confirm: this.$t('popUp.unsharedResume.button'),
          },
        });
        if (result) {
          await this.$store.dispatch('resume.unshare', {
            resumeId: resume.id,
            userId: this.user.id,
          });
          this.$emit('reload');
        }
      } catch (e) {
        console.error(e);
      }
    },
    colorPaletteLogo(date) {
      const colorPalette = ['grey', 'blue', 'green', 'light-green', 'purple', 'red', 'yellow', 'orange'];
      const currentColor = colorPalette[Math.floor(Date.parse(date) % 8)];
      return currentColor;
    },
    async launchSearch() {
      await this.$store.dispatch('resume.search', {
        search: this.search,
        pageNumber: 0,
      });
    },
  },
  watch: {
    async search() {
      if (this.search.length) {
        this.workspace = this.workspaceTypes.search;
        try {
          await this.searchDebounce();
        } catch (e) {
          if (e.message !== 'Canceled') {
            console.log(e);
          }
        }
      }
    },
  },
  computed: {
    ...mapGetters(['searchResult', 'isFetching']),
    collaborators() {
      return this.sharedInformation.collabos.length < 5 ? this.sharedInformation.collabos : [];
    },
    searchResultItems() {
      return this.searchResult.items;
    },
  },
};
